import { createFileRoute } from '@tanstack/react-router'
import PurchaseRequestScreen from './-components/screen'
import { PurchaseOrderParams } from '../purchase-order-list/-data/model'
import { pharmacyClient } from '@/connect'
import { Loading } from '@/layouts/loading'

export const Route = createFileRoute('/(pharma)/_layout/reports/purchase-requests-list/')({
  component: PurchaseRequestScreen,
  validateSearch: PurchaseOrderParams,
})